module.exports = __webpack_public_path__ + "h5/img/fail.1ae1f644.png";